<template>
    <div class="vue-main-page">
        <router-view/>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            };
        },
        computed: {},
        mounted() {
            // this.$Message.info('This is a info tip');
        },
    };
</script>

